"use client";

import React, { cloneElement, ReactNode, useState } from "react";
export default function GradientSvg({
  children,
  updateType = "path"
}: {
  children: ReactNode;
  updateType?: string | string[];
}) {
  const [isHover, setIsHover] = useState(false);
  const updateFill = (element: React.ReactElement): React.ReactElement => {
    if (typeof element.type === "function") {
      // 克隆组件并更新 fill 属性
      return cloneElement(element, {
        fill: isHover ? "url(#customGradient)" : element.props.fill
      });
    }
    if (Array.isArray(updateType)) {
      if (updateType.includes(element.type as string)) {
        return cloneElement(element, {
          fill: isHover ? "url(#customGradient)" : element.props.fill
        });
      }
    }
    if (element.type === updateType) {
      return cloneElement(element, {
        fill: isHover ? "url(#customGradient)" : element.props.fill
      });
    }

    // 如果元素有子节点，递归更新
    if (element.props.children) {
      return cloneElement(element, {
        children: React.Children.map(element.props.children, updateFill)
      });
    }
    return element;
  };

  // 更新传入的 children
  const clonedChildren = updateFill(children as React.ReactElement);
  return <div data-sentry-component="GradientSvg" data-sentry-source-file="GradientSvg.tsx">
      <div onMouseEnter={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)} className="absolute h-full w-full"></div>
      <svg width="0" height="0" xmlns="http://www.w3.org/2000/svg" style={{
      position: "absolute"
    }} data-sentry-element="svg" data-sentry-source-file="GradientSvg.tsx">
        <defs data-sentry-element="defs" data-sentry-source-file="GradientSvg.tsx">
          <linearGradient id="customGradient" x1="0" x2="1" y1="0" y2="0" data-sentry-element="linearGradient" data-sentry-source-file="GradientSvg.tsx">
            <stop offset="0%" stopColor="hsl(var(--gradient-start))" data-sentry-element="stop" data-sentry-source-file="GradientSvg.tsx" />
            <stop offset="100%" stopColor="hsl(var(--gradient-end))" data-sentry-element="stop" data-sentry-source-file="GradientSvg.tsx" />
          </linearGradient>
        </defs>
      </svg>
      {clonedChildren}
    </div>;
}